module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"contact-warehouse":{"longer":"この倉庫にお問い合わせ","shorter":"問い合わせ"}}}')
  delete Component.options._Ctor
}
